module.exports = __webpack_public_path__ + "img/vip_header.55029fa1.png";